import script from "./ProjectStatistic.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectStatistic.vue?vue&type=script&setup=true&lang=js"

import "./ProjectStatistic.vue?vue&type=style&index=0&id=66e3ec86&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e3ec86"]])

export default __exports__